
/**
 * Utility functions for managing route paths consistently across the application
 */

/**
 * Determines if the current path is within the dashboard section
 * @returns boolean indicating if current path includes dashboard
 */
export const isInDashboard = (): boolean => {
  return window.location.pathname.includes('/dashboard');
};

/**
 * Generates the correct course player URL based on current location
 * @param courseId The ID of the course to generate a URL for
 * @returns The appropriate URL path for the course player
 */
export const getCoursePlayerUrl = (courseId: string): string => {
  // Always use the dashboard path for consistency and to avoid navigation issues
  return `/dashboard/student/my-learning/course/${courseId}`;
};

/**
 * Generates the correct my learning URL based on current location
 * @returns The appropriate URL path for the my learning page
 */
export const getMyLearningUrl = (): string => {
  // Since My Learning is now unified with Dashboard, always return the Dashboard path
  return `/dashboard/student`;
};

/**
 * Checks if the current path is for a course player page
 * @param pathname The current location pathname
 * @param courseId Optional specific course ID to check
 * @returns boolean indicating if the path is a course player route
 */
export const isCoursePlayerRoute = (pathname: string, courseId?: string): boolean => {
  const isPlayerRoute = 
    pathname.includes('/my-learning/course/') || 
    pathname.includes('/dashboard/student/my-learning/course/');
    
  if (!courseId) return isPlayerRoute;
  
  return isPlayerRoute && (
    pathname.includes(`/my-learning/course/${courseId}`) || 
    pathname.includes(`/dashboard/student/my-learning/course/${courseId}`)
  );
};

/**
 * Formats and returns the fully qualified path for the checkout page
 * @param username Optional username for course-specific checkout
 * @param courseSlug Optional course slug for course-specific checkout
 * @returns The appropriate URL for checkout
 */
export const getCheckoutUrl = (username?: string, courseSlug?: string): string => {
  if (username && courseSlug) {
    return `/${username}/${courseSlug}/checkout`;
  }
  return `/global-checkout`;
};
